module.exports = __webpack_public_path__ + "img/ebay.6a58febd.jpg";